


















































import Vue from 'vue';
import * as matrix from "./assets/script"

export default Vue.extend({
  name: 'App',
  data() {
    return { 
      countLine: 1,
      countColumn: 1,
      resultMatrix: [[0]],
    }
  },
  methods: {
    createTable() {
      if (this.countLine > this.countColumn) {
        return alert("Количество столбцов должно быть больше или равно числу строк")
      }

      const mtx = matrix.CreateMatrix(this.countLine, this.countColumn)
      const beta = 0.6 / (matrix.NormOne(matrix.TransposingMatrix(mtx)) * matrix.NormInfinity(mtx))

      let Xk = matrix.MultiplyMatrixByNumber(matrix.TransposingMatrix(mtx), beta)
      let Xk1: number[][]
      let iteration = 0

      for (let err = 1; err >= 10e-7; Xk = Xk1) {
        Xk1 = matrix.MultiplyMatrix(Xk, matrix.DifferenceMatrix(matrix.UnitMatrix(mtx.length), matrix.MultiplyMatrix(mtx, Xk)))
        err = matrix.NormInfinity(matrix.DifferenceMatrix(Xk1, Xk)) / ( 1 + matrix.NormInfinity(Xk))
        iteration += 1
      }

      console.table(Xk)
      this.resultMatrix = Xk
    },
    clearTable() {
      this.countLine = 1
      this.countColumn = 1
      this.resultMatrix = [[0]]
    },
  }
});
